import { Component, h } from '@monygroupcorp/microact';

/**
 * SwapButton Component
 *
 * Main swap action button with state management.
 *
 * @class SwapButton
 * @extends Component
 */
export class SwapButton extends Component {
    /**
     * @param {Object} props - Component props
     * @param {string} props.direction - Current swap direction ('buy' or 'sell')
     * @param {boolean} props.disabled - Whether button should be disabled
     * @param {Function} props.onClick - Callback when button is clicked
     */
    constructor(props = {}) {
        super(props);
    }

    /**
     * Handle button click
     * @param {Event} e - Click event
     */
    handleClick(e) {
        e.preventDefault();
        if (!this.props.disabled && this.props.onClick) {
            this.props.onClick(e);
        }
    }

    render() {
        const { direction, disabled } = this.props;
        const buttonText = direction === 'buy' ? 'Buy $EXEC' : 'Sell $EXEC';

        return h('button', {
            className: 'swap-button',
            disabled: disabled,
            onClick: this.bind(this.handleClick)
        }, buttonText);
    }
}

export default SwapButton;
